// Siglas das 27 UFs e as opções de select correspondentes (PO1-3856). Antes
// viviam em views/Empresa/ConsultaNotasFiscais/filtros.js; agora são
// compartilhadas com o Catálogo de Transportadoras ("Atende a rota").
export const UFS = [
  "AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO",
];

export const UF_OPTIONS = [{ value: "", label: "Todas" }].concat(UFS.map((uf) => ({ value: uf, label: uf })));
